import styles from "./MypageInput.module.scss";
import { fetchPostcode } from "../../utils/searchAddress";
import {
  validateRequired,
  validateMaxlength,
  validatePostcode,
} from "../../utils/validate";

const MypagePostcodeTextField = ({
  type = "text",
  name = "postcode",
  label = "郵便番号",
  maxLength = 8,
  register,
  validation = {},
  errors,
  watch,
  setValue,
  prefField = "pref",
  addressField = "address",
  required = false,
  placeholder = "",
  autocomplete = null,
  isStatic = false,
  readOnly = false,
}) => {
  // 郵便番号から住所自動入力
  const searchAddress = async (e) => {
    const value = formatPostCode(e.target.value);
    const result = await fetchPostcode(value);

    if (typeof result !== "undefined" && result) {
      setValue(prefField, result.prefecture);
      setValue(addressField, result.city + result.suburb);
    }
  };

  const formatPostCode = (pc_value) => {
    let value = pc_value;
    if (pc_value.length > 0) {
      value = pc_value.replace(/[^0-9]/g, ""); // 数字以外を除去
      if (value.length > 3) {
        value = value.slice(0, 3) + "-" + value.slice(3, 7); // ハイフンを追加
        setValue(name, value);
      }
    }
    return value;
  };

  const returnText = () => {
    const value = watch(name);
    return typeof value !== "undefined" &&
      value !== null &&
      value.length > 0 ? (
      value
    ) : (
      <p>&emsp;</p>
    );
  };

  /**** バリデーションルール設定 ****/
  // 項目ごとのルール + 郵便番号ルール
  let txt_validation = { ...validation, ...validatePostcode() };

  if (maxLength) {
    // 最大文字数が設定されていたら最大文字数バリデーションルール設定
    txt_validation = { ...txt_validation, ...validateMaxlength(maxLength) };
  }
  if (required) {
    // 必須項目なら必須バリデーションルール設定
    txt_validation = { ...txt_validation, ...validateRequired() };
  }

  return (
    <div className={styles.mypageform__block}>
      <div className={styles.mypageform__ttl}>
        {label}
        <span className={styles.mypageform__ttl__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </div>
      <div
        className={`${styles.mypageform__field} ${isStatic ? "d-none" : ""}`}
      >
        <input
          type={type}
          name={name}
          className={`${styles.mypageform__postcodetxt} form-control ${
            errors[name] && !isStatic ? "is-invalid" : ""
          } ${isStatic ? "form-control-plaintext" : ""}`}
          maxLength={maxLength}
          placeholder={isStatic ? "" : placeholder}
          autoComplete={autocomplete}
          {...register(name, txt_validation)}
          readOnly={isStatic || readOnly}
          onBlur={(e) => searchAddress(e)}
        />
        <>
          {errors[name] ? (
            <p className={`invalid-feedback ${styles.mypageform__msg}`}>
              {errors[name].message}
            </p>
          ) : (
            <></>
          )}
        </>
      </div>
      {/* 確認画面表示用 */}
      {isStatic && (
        <div className={`${styles.mypageform__label} ws-pre-wrap ps-4`}>
          {returnText()}
        </div>
      )}
    </div>
  );
};

export default MypagePostcodeTextField;
